import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { WorkspaceService as WorkspaceDataService } from '@app/shared/store/data-services';
import { WorkspaceSelectors } from '@app/shared/store/selectors';
import { WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { fuseAnimations } from '@keeps-platform-frontend-workspace/layout';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'workspace-profile',
  styleUrls: ['./workspace-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  standalone: false,
  template: `
    <app-workspace-page-wrapper class="flex flex-1" [workspace]="workspace$ | async">
      <mat-tab-group [selectedIndex]="1">
        <mat-tab [label]="'WORKSPACES.DETAIL.TABS.GENERAL' | transloco">
          <app-workspace-info></app-workspace-info>
        </mat-tab>
        <mat-tab [label]="'WORKSPACES.DETAIL.TABS.LAYOUT' | transloco">
          <div class="tab-content p-6">
            <app-workspace-layout></app-workspace-layout>
          </div>
        </mat-tab>
        <mat-tab *ifRoles="['keeps_platform_admin']" [label]="'WORKSPACES.DETAIL.TABS.SETTING' | transloco">
          <div class="tab-content p-6">
            <app-workspace-settings></app-workspace-settings>
          </div>
        </mat-tab>
        <mat-tab [label]="'JOB_MANAGEMENT.TAB_TITLE' | transloco">
          <div class="tab-content p-6" fuseScrollbar>
            <app-job-management-wrapper></app-job-management-wrapper>
          </div>
        </mat-tab>

        <mat-tab *ifRoles="['keeps_admin', 'company_admin']" label="SMTP">
          <div class="tab-content p-6" fuseScrollbar>
            <app-smtp></app-smtp>
          </div>
        </mat-tab>
      </mat-tab-group>
    </app-workspace-page-wrapper>
    <kp-loading-shade *ngIf="loading$ | async"></kp-loading-shade>
  `,
})
export class WorkspaceProfileComponent implements OnDestroy, OnInit {
  loading$: Observable<boolean>;
  isKeepsAdmin: boolean;
  workspace$: Observable<any>;

  private _id: string;

  constructor(
    private store: Store,
    private workspaceService: WorkspaceService,
    private _workspaceDataService: WorkspaceDataService,
  ) {
    this._id = this.workspaceService.getCurrentWorkspace().id;
    this.workspace$ = this.store.select(WorkspaceSelectors.selectCurrentWorkspace(this._id));
    this.loading$ = this._workspaceDataService.loading$;
    this.isKeepsAdmin = true;
  }

  ngOnInit(): void {
    const { id } = this.workspaceService.getCurrentWorkspace();
    this._workspaceDataService
      .getByKey(id)
      .subscribe((w) => this.workspaceService.setCurrentWorkspace({ ...w } as unknown));
  }

  ngOnDestroy(): void {
    this._workspaceDataService.clearCache();
  }
}
